import $ from "jquery";
import "owl.carousel";

console.log("app.js loaded");

import { playVideo } from "./components/video";
import { heroVenueMedia } from "./components/hero-venues";
import { search } from "./components/search";
import { nav } from "./components/nav";

(function ($) {
  $(document).ready(function () {
    heroVenueMedia();
    search();
    nav();

    /** FAQs accordion: one open at a time, jQuery slideToggle */
    const faqDuration = 350;
    $(document).on("click", "[data-faq-toggle]", function () {
      const $btn = $(this);
      const $list = $btn.closest(".faqs__list");
      const targetId = $btn.attr("aria-controls");
      const $target = targetId ? $("#" + targetId) : $btn.siblings(".faqs__answer-wrap").first();
      const wasOpen = $target.is(":visible");

      $list.find("[data-faq-toggle]").attr("aria-expanded", "false");
      $list.find(".faqs__answer-wrap").slideUp(faqDuration).promise().done(function () {
        if (!wasOpen) {
          $target.slideDown(faqDuration);
          $btn.attr("aria-expanded", "true");
        }
      });
    });

    /** Venue gallery */
    $(".venue-gallery").owlCarousel({
      items: 2,
      center: true,
      loop: true,
      nav: true,
      dots: false,
      margin: 40,
    });

    $(".landscape-gallery-container").owlCarousel({
      center: true,
      loop: true,
      margin: 25,
      nav: true,
      responsive: {
        0: {
          items: 1,
        },
        768: {
          items: 1.675,
        },
      },
    });

    $(".portrait-gallery-container").owlCarousel({
      items: 3,
      center: true,
      loop: true,
      margin: 25,
      nav: true,
      responsive: {
        0: {
          items: 1,
        },
        768: {
          items: 2,
        },
        1024: {
          items: 3,
        },
      },
    });

    const $promotionCarousel = $(".promotion-carousel");
    $promotionCarousel.each((index, element) => {
      const $self = $(element);
      const slideCount = $self.find(".promotion-slide").length;

      $self.owlCarousel({
        margin: 25,
        nav: true,
        responsive: {
          0: {
            loop: slideCount > 1 ? true : false,
            items: 1,
          },
          768: {
            items: 2,
            loop: slideCount > 2 ? true : false,
          },
          1024: {
            items: 3,
            loop: slideCount > 3 ? true : false,
          },
        },
      });
    });

    const $relatedVenuesCarousel = $(".related-venues-carousel");
    $relatedVenuesCarousel.each((index, element) => {
      const $self = $(element);
      const slideCount = $self.find(".venue-slide").length;
      //loop not functioning correctly, unsure why
      $self.owlCarousel({
        margin: 25,
        nav: true,

        responsive: {
          0: {
            loop: slideCount > 1 ? true : false,
            items: 1,
          },
          768: {
            items: 2,
            loop: slideCount > 2 ? true : false,
          },
          1024: {
            items: 3,
            loop: slideCount > 3 ? true : false,
          },
        },
      });
    });

    const $titleAndIntroCarousel = $(".title-and-intro-carousel");
    $titleAndIntroCarousel.each((index, element) => {
      const $self = $(element);
      const slideCount = $self.find(".title-and-intro-slide").length;
      $self.owlCarousel({
        items: 1,
        margin: 25,
        nav: true,
        loop: slideCount > 1,
      });
    });

    $("a").on("click", function (e) {
      // Skip if it's a dropdown toggle
      if ($(this).hasClass('dropdown-toggle')) {
        return;
      }
      
      // Skip if it's an anchor link
      if ($(this).attr("href").startsWith("#")) {
        return;
      }
    
      // Only prevent default and handle custom behavior for search links
      if ($(this).hasClass("wait")) {
        e.preventDefault();
        let searchValue = $(".nav-search input").val();
    
        if ($(window).width() < 768) {
          searchValue = $(".nav-search-dropdown input").val();
        }
    
        let href = $(this)
          .attr("href")
          .replace(/search/g, searchValue);
    
        window.location.href = href;
      }
    });

    $(".video-wrapper .play-button").on("click", (e) =>
      playVideo($(e.currentTarget))
    );

    if ("ontouchstart" in document.documentElement) {
      $(".hamburger").on("click", function () {
        $(this).toggleClass("is-active");
        $(".main-nav").toggle();
      });

      $(".nav-search svg").on("click", function () {
        $('.nav-search input[name="s"]').toggleClass("is-active");
        $(".nav-search-dropdown").toggle();
      });
    } else {
      $(".hamburger").on("mouseover", function () {
        $(this).addClass("is-active");
        $(".main-nav").show().height($(".media-wrapper").height());
        $(".nav-search-dropdown").hide();
      });

      $(".left-column").on("mouseleave", function () {
        $(".hamburger").removeClass("is-active");
        $(".main-nav").hide();

        $(".nav-search input").removeClass("is-active");
        $(".nav-search-dropdown").hide();

        $(this).closest("div").find("svg").removeClass("is-active");
      });

      $(".nav-search input").on("mouseover", function () {
        $(".main-nav").hide();
        $(this).addClass("is-active");
        $(this).closest("div").find("svg").addClass("is-active");
        $(".nav-search-dropdown").show().height($(".media-wrapper").height());
      });
    }

    $(document).on("click", ".sub-menu-arrow", function () {
      $(this).parents("li").find(".mega-menu-sub").stop().slideToggle();
    });

    // Extract the value of the ‘notes’ parameter from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const notes = urlParams.get("notes");
    let customAttrValue = notes;

    // Iterate over all widgets and apply the logic to each one
    if (
      window.DMN &&
      window.DMN.BookingFormHelper &&
      window.DMN.BookingFormHelper.widgets
    ) {
      window.DMN.BookingFormHelper.widgets.forEach((widget) => {
        if (customAttrValue) {
          widget.setNotes(customAttrValue);
        }
      });
    }

    $(document).on("click", "button[data-modal-target]:not([data-etm-modal-target])", function () {
      // Only handle legacy modal buttons that don't have the ETM plugin's data-etm-modal-target attribute
      let modalId = $(this).attr("data-modal-target");
      let modal = $("#" + modalId);
      
      if (
        window.DMN &&
        window.DMN.BookingFormHelper &&
        window.DMN.BookingFormHelper.widgets
      ) {
        window.DMN.BookingFormHelper.widgets.forEach((widget) => {
          if (customAttrValue) {
            widget.setNotes(customAttrValue);
          }
        });
      }
      
      // Handle legacy modal system
      $("html").addClass("modal-active");
      $(modal).closest(".modal-widget").addClass("active");
      $(modal).addClass("active");
    });



    // Handle choice buttons in choice modal - close current and open target
    $(document).on("click", ".booking-choice-btn[data-dismiss='modal']", function () {
      let targetModalId = $(this).attr("data-modal-target");
      let targetModal = $("#" + targetModalId);
      
      // Close the current modal
      $("html").removeClass("modal-active");
      $(".modal-widget").removeClass("active");
      $(".modal").removeClass("active");
      
      // Small delay to ensure current modal is closed before opening new one
      setTimeout(function() {
        // Open the target modal
        if (targetModal.length) {
          if (
            window.DMN &&
            window.DMN.BookingFormHelper &&
            window.DMN.BookingFormHelper.widgets
          ) {
            window.DMN.BookingFormHelper.widgets.forEach((widget) => {
              if (customAttrValue) {
                widget.setNotes(customAttrValue);
              }
            });
          }
          $("html").addClass("modal-active");
          $(targetModal).closest(".modal-widget").addClass("active");
          $(targetModal).addClass("active");
        }
      }, 100);
    });

    // Booking option button clicks are now handled by the ETM Booking Modal plugin
    // This ensures proper separation of concerns and avoids conflicts

    $(document).on("click", ".modal-widget .modal-header button", function () {
      // Handle legacy theme modals
      if (
        window.DMN &&
        window.DMN.BookingFormHelper &&
        window.DMN.BookingFormHelper.widgets
      ) {
        window.DMN.BookingFormHelper.widgets.forEach((widget) => {
          if (customAttrValue) {
            widget.setNotes(customAttrValue);
          }
        });
      }
      $("html").removeClass("modal-active");
      $(".modal-widget").removeClass("active");
      $(".modal").removeClass("active");
    });

    /** Slide toggle for venue column details */
    $(document).on("click", ".details-column h3", function () {
      $(this).parents(".details-column").toggleClass("active");
      $(this).next(".details-column-inner").stop().slideToggle();
    });

    /** Venue strapline */
    $(".submenu-btn").on("click", function () {
      $(this).next(".sub-menu").stop().slideToggle();
    });

    $(".venue-strapline .sub-menu a").on("click", function (e) {
      // If it's an anchor link, let the dedicated handler below manage it.
      if ($(this).attr("href").startsWith("#")) {
        // The other handler will call e.preventDefault()
        return;
      }
      // For external links, just slide up the menu. The browser will navigate.
      $(this).closest(".sub-menu").slideUp();
    });

    // Function to handle scrolling to an element
    const scrollToElement = (selector) => {
      const element = $(selector);
      if (element.length) {
        // Assuming element is already defined and you want to scroll to this element
        var totalOffset = element.offset().top;

        // Subtract the .nav-bar height
        var navBarHeight = $(".nav-bar").outerHeight(); // outerHeight includes padding and border
        totalOffset -= navBarHeight;

        // If on a .single-venues page, subtract the venue-strapline height
        if ($("body").hasClass("single-venues")) {
          var venueStraplineHeight = 64; // Always get the close height
          totalOffset -= venueStraplineHeight;
        }

        // Perform the scroll
        $("html, body").animate(
          {
            scrollTop: totalOffset,
          },
          "smooth"
        );
      }
    };

    // Attach click event to all anchor tags
    $(document).on("click", 'a[href^="#"]', function (event) {
      event.preventDefault();
      const hash = $(this).attr("href");
      const $link = $(this);

      // Check if the link is inside the venue strapline menu that is currently visible
      const $subMenu = $link.closest(".venue-strapline .sub-menu");
      if ($subMenu.length && $subMenu.is(":visible")) {
        // If so, slide up the menu first, then scroll in the callback to avoid animation conflicts
        $subMenu.slideUp(400, function () {
          scrollToElement(hash);
        });
      } else {
        // Otherwise, just scroll
        scrollToElement(hash);
      }
    });

    // Ensure the entire page is loaded before scrolling to the hash
    $(window).on("load", function () {
      const hash = window.location.hash;
      if (hash) {
        scrollToElement(hash);
      }
    });

    /** Setting equal heights for titles on events layouts */
    function setEqualHeightsPerRow() {
      // Object to hold each row's maximum height
      var rowMaxHeights = {};

      // Reset the height
      $(".two-images-and-details h4").height("auto");

      // Group h4 elements by their top offset and find the max height for each row
      $(".two-images-and-details h4").each(function () {
        var topOffset = Math.floor($(this).offset().top); // Use Math.floor to normalize offset

        if (!rowMaxHeights[topOffset]) {
          rowMaxHeights[topOffset] = $(this).height();
        } else {
          if ($(this).height() > rowMaxHeights[topOffset]) {
            rowMaxHeights[topOffset] = $(this).height();
          }
        }
      });

      // Set each h4 height to the max height of its row
      $(".two-images-and-details h4").each(function () {
        var topOffset = Math.floor($(this).offset().top); // Use Math.floor to normalize offset
        $(this).height(rowMaxHeights[topOffset]);
      });
    }

    // Run the function on page load
    setEqualHeightsPerRow();

    // Debounce function to limit the rate at which a function is executed
    function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }

    // Run the function again when the window is resized, with debounce
    $(window).resize(
      debounce(function () {
        setEqualHeightsPerRow();
      }, 50)
    ); // Adjust debounce time as needed

    /** Read more enabled */
    $(".two-images-and-details .content").each(function () {
      var $content = $(this);
      if ($content.hasClass("read-more-enabled")) {
        var fullText = $content.text();
        if (fullText.length > 100) {
          var trimmedText = fullText.substring(0, 100) + "...";
          var $toggleLink = $('<a href="#" class="toggle-text">Read more</a>');

          // Wrap the text in a span for easier manipulation
          var $textSpan = $("<span>").text(trimmedText);
          $content.empty().append($textSpan, $toggleLink);

          $toggleLink.click(function (e) {
            e.preventDefault();
            // Toggle based on the link's text
            if ($toggleLink.text() === "Read more") {
              $textSpan.text(fullText); // Use full text
              $toggleLink.text("Read less");
            } else {
              $textSpan.text(trimmedText); // Reapply trimmed text
              $toggleLink.text("Read more");
            }
          });
        }
      }
    });

    // Custom notes for the embedded booking widgets
    let widgetContainer = document.getElementById("widget-data-container");

    // If widgetContainer exists
    if (widgetContainer) {
      widgetContainer.addEventListener("click", function (event) {
        // If the clicked element contains the class .vdp-datepicker
        if (event.target.closest(".vdp-datepicker")) {
          // If 'notes' parameter does not exist, use data-custom-attr
          if (!customAttrValue) {
            const widgetContainer = document.getElementById(
              "widget-data-container"
            );
            if (widgetContainer) {
              customAttrValue =
                widgetContainer.getAttribute("data-custom-attr");
            }
          }

          // If customAttrValue exists
          if (customAttrValue) {
            // Add the notes
            let widget = window.DMN && window.DMN.BookingFormHelper.widgets[0];
            if (widget && typeof widget.setNotes === "function") {
              widget.setNotes(customAttrValue);
            }
          }
        }
      });
    }
    $(".two-images-and-details h2").on("click", function () {
      if ($(window).width() <= 767) {
        $(this).find("svg").toggleClass("active");
        $(this).toggleClass("active");
        $(this).closest(".two-images-and-details").find(".blocks").toggle();
      }
    });

    /** Sign up */
    $("#promotion-signup").on("submit", function (event) {
      event.preventDefault();

      $(".signup__wrapper").addClass("submitting");

      var signupForm = $("#promotion-signup");

      $.ajax({
        url: signupForm.attr("action"),
        type: "POST",
        data: signupForm.serialize(),
        success: function (result) {
          $(".signup__wrapper").removeClass("submitting");
          $(".signup__wrapper").addClass("submitted");
          $("#finish-message").text(result);
        },
        error: function (xhr, textStatus, errorThrown) {
          //Couldn't connect to server side file
          $(".signup__wrapper").removeClass("submitting");
          $(".signup__wrapper").addClass("submitted");
          $("#finish-message").text(
            "Connection failure, please refresh and try again"
          );
        },
      });
    });

    // Clean up content in the .privacy-policy-box by removing empty p tags or p tags with just &nbsp; in it
    $(".privacy-policy-box p").each(function () {
      if (
        $(this)
          .html()
          .replace(/\s|&nbsp;/g, "").length === 0
      ) {
        $(this).remove();
      }
    });

    // Add this inside the existing jQuery(document).ready function
    $(document).on("click", ".privacy-policy-link", function (e) {
      e.preventDefault();
      $(".privacy-policy-box").slideToggle();
    });

    $(document).on("click", ".close-policy", function () {
      $(".privacy-policy-box").slideUp();
    });
  });
})(jQuery);
